module.exports = __webpack_public_path__ + "static/media/favorite_store.ecd6ab7d.svg";